import { createDetailedBookingIMPFormConfig } from '../../config/createDetailedBookingIMPFormConfig';
import { getSlotPackageDisplayName } from '../../constants/DetailedBookingConstants';
import {
  DetailedBookingIMPData,
  DetailedBookingIMPMainFormFieldErrors,
  SlotPackage,
} from '../../interface/DetailedBookingInterface';
import { FormFieldWrapper } from '../FormFieldWrapper';

interface RenderMainFormProps {
  formData: DetailedBookingIMPData;
  handleInputChange: (field: string, value: string) => void;
  fieldErrors: DetailedBookingIMPMainFormFieldErrors;
  hasValidationBeenTriggered: boolean;
  isLoadingSlotPackages: boolean;
  slotPackagesData: SlotPackage[];
  hideCommonFields: boolean;
  preSelectedSlotNames?: string[];
}

const IMPMainForm = ({
  formData,
  handleInputChange,
  fieldErrors,
  hasValidationBeenTriggered,
  slotPackagesData,
  isLoadingSlotPackages,
  hideCommonFields = false,
  preSelectedSlotNames = [],
}: RenderMainFormProps) => {
  const errorsToShow = hasValidationBeenTriggered
    ? fieldErrors
    : {
        entryNumber: '',
        slotForGP: '',
        valueBlockedByLineItem: '',
        impressionsBlockedOverContextualNode: '',
      };

  const getSlotPackageOptions = () => {
    if (!slotPackagesData.length || isLoadingSlotPackages) return [];

    return slotPackagesData
      .filter((pkg) => !preSelectedSlotNames.includes(pkg.slotPackageName))
      .map((pkg) => ({
        id: `slot-package-${pkg.slotPackageName}`,
        value: pkg.slotPackageName,
        label: getSlotPackageDisplayName(pkg.slotPackageName),
      }));
  };

  const formConfig = createDetailedBookingIMPFormConfig(
    formData,
    handleInputChange,
    errorsToShow,
    getSlotPackageOptions(),
    hideCommonFields
  );
  return (
    <>
      {formConfig.map((field) => (
        <FormFieldWrapper
          key={field.id}
          id={field.id}
          type={field.type}
          label={field.label}
          value={field.value}
          onChange={field.onChange}
          placeholder={field.placeholder}
          disabled={field.disabled}
          options={field.options}
          error={field.error}
        />
      ))}
    </>
  );
};

export default IMPMainForm;
